<template>
  <table class="table table-hover">
    <thead>
      <tr>
        <th></th>
        <th>Free trial</th>
        <th>Basic</th>
        <th>Premium</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Price</th>
        <td>-</td>
        <td>$25 for lifetime access</td>
        <td>$75 for lifetime access</td>
      </tr>
      <tr>
        <th><router-link to="/help/equity-calculator" target="_blank">Equity Calculator</router-link></th>
        <td>14 days</td>
        <td>✅</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/hit-calculator" target="_blank">Hit Calculator</router-link></th>
        <td>14 days</td>
        <td>✅</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/should-you-bluff" target="_blank">Should You Bluff?</router-link></th>
        <td>14 days</td>
        <td>✅</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/should-you-call" target="_blank">Should You Call?</router-link></th>
        <td>14 days</td>
        <td>✅</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/equity-matrix" target="_blank">Equity Matrix</router-link></th>
        <td>14 days</td>
        <td>❌</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/range-constructor" target="_blank">Range Constructor</router-link></th>
        <td>14 days</td>
        <td>❌</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/three-bet-cbet-explorer" target="_blank">Threebet-Cbet Explorer</router-link></th>
        <td>14 days</td>
        <td>❌</td>
        <td>✅</td>
      </tr>
      <tr>
        <th><router-link to="/help/breakeven-percentage-for-bluffing-the-turn" target="_blank">Breakeven Percentage For Bluffing The Turn</router-link></th>
        <td>14 days</td>
        <td>❌</td>
        <td>✅</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'pricing-table',
};
</script>

<style lang="css" scoped>
  th:not(:first-of-type), td {
    text-align: center;
  }

  @media (min-width: 680px) {
    thead th:first-of-type {
      width: 175px;
    }
  }

  @media (max-width: 679px) {
    thead th:first-of-type {
      width: 150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/utilities/pricing-table.vue